/**
 * Prices arrive from the API as decimal strings ("399.00", "4788.00").
 *
 * Shown raw they read as machine output, and a four-figure annual total with no
 * separator ("$4788.00") is genuinely hard to scan. Whole amounts drop the
 * cents; anything with a fraction keeps both places.
 */
export const money = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  if (!isFinite(n)) return value;
  return n.toLocaleString("en-CA", {
    minimumFractionDigits: n % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
};

export default money;
